export const GLOBAL_STATE = 'Conference'

export const CONFERENCE = 'CONFERENCE' as const
export const CONFERENCE_ALL = 'CONFERENCE_ALL' as const
export const CONFERENCE_ARTICLE_BY_ID = 'CONFERENCE_ARTICLE_BY_ID' as const
export const CONFERENCE_ARTICLE_CREATE = 'CONFERENCE_ARTICLE_CREATE' as const
export const CONFERENCE_ARTICLE_ALL = 'CONFERENCE_ARTICLE_ALL' as const
export const CONFERENCE_CATEGORY_ALL = 'CONFERENCE_CATEGORY_ALL' as const
